import { atom } from 'recoil';

export const authModalControl = atom<{
  login: boolean;
  signUp: boolean;
  forgotPassword: boolean;
  bookId: string;
  comingSoon: string;
  noRedirect: boolean;
  headingCopy?: string;
  subHeadingCopy?: string;
  amazonOrderId?: string;
}>({
  key: 'authModalControl',
  default: {
    login: false,
    signUp: false,
    forgotPassword: false,
    bookId: '',
    comingSoon: '',
    noRedirect: false,
    headingCopy: '',
    subHeadingCopy: '',
    amazonOrderId: '',
  },
});

export const tokenUpdate = atom<boolean>({
  key: 'tokenUpdate',
  default: false,
});
